import { ReactNode, useState } from "react";
import styles from "./Tooltip.module.css";

export enum TriggerType {
    HOVER,
    CLICK,
}

/**
 * @author cwlee
 * @date 2024-08-22 15:18:54
 * @remark 툴팁
 * @param contents (required)
 */
export interface TooltipProps {
    message: ReactNode;
    children: ReactNode;
    triggerType: TriggerType;
}

const Tooltip = ({ children, message, triggerType }: TooltipProps) => {
    const [visible, setVisible] = useState(false);

    // 25.05.15 | Hover 방식으로 수정 by YoungJun
    const showTooltip = () => setVisible(true);
    const hideTooltip = () => setVisible(false);

    const handleClick = () => {
        setVisible(true);
        setTimeout(() => {
            setVisible(false);
        }, 2000);
    };

    const eventProps =
        triggerType === TriggerType.HOVER
            ? {
                  onMouseEnter: showTooltip,
                  onMouseLeave: hideTooltip,
              }
            : {
                  onClick: visible ? undefined : handleClick,
              };

    return (
        // 25.06.23 | smyun | 호버 또는 클릭 타입을 정해서 보여줄 수 있도록 수정
        <div className={styles["tooltip-container"]} {...eventProps}>
            {visible && <div className={styles["tooltip"]}>{message}</div>}
            {children}
        </div>
    );
};

export default Tooltip;
